import { render } from "./AudioShow.vue?vue&type=template&id=dc446af4&scoped=true"
import script from "./AudioShow.vue?vue&type=script&lang=js"
export * from "./AudioShow.vue?vue&type=script&lang=js"

import "./AudioShow.vue?vue&type=style&index=0&id=dc446af4&lang=scss&scoped=true"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc446af4"]])

export default __exports__